import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setToast as setToastAction } from '../actions/toast-actions';

const useGlobalToast = () => {
  const dispatch = useDispatch();
  const setToast = useCallback((...args) => dispatch(setToastAction(...args)), [
    dispatch,
  ]);

  return {
    setToast,
  };
};

export default useGlobalToast;
